import React from "react";
interface BatteryTubeProps {
  level?: number; // 0 - 100
}

const BatteryTube: React.FC<BatteryTubeProps> = ({ level=0 }) => {
  const safeLevel = Math.max(0, Math.min(level, 100));

  const getColor = () => {
    if (safeLevel <= 20) return "#dc3545"; // red
    if (safeLevel <= 60) return "#ffc107"; // yellow
    return "#28a745"; // green
  };

  return (
     <div className="d-flex flex-column align-items-center">
      {/* Battery terminal at the top */}
      <div
        className="bg-dark rounded-top"
        style={{ width: "40px", height: "10px" }}
      ></div>

      {/* Battery container */}
      <div
        className="position-relative border border-dark rounded"
        style={{
          width: "80px",
          height: "250px",
          backgroundColor: "#f8f9fa",
          overflow: "hidden",
        }}
      >
        {/* Fill level */}
        <div
          className="position-absolute bottom-0 w-100"
          style={{
            height: `${safeLevel}%`,
            backgroundColor: getColor(),
            transition: "height 0.5s ease",
            zIndex: 1,
          }}
        ></div>

        {/* Percentage text (centered) */}
        <div
          className="position-absolute top-50 start-50 translate-middle"
          style={{
            zIndex: 2,
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: safeLevel <= 20 ? "#000" : "#fff",
            textShadow: "0 0 5px rgba(0,0,0,0.3)",
          }}
        >
          {safeLevel}%
        </div>
      </div>
    </div>
  );
};

export default BatteryTube;